import PropTypes from "prop-types";
import { parsePhoneNumberFromString } from "libphonenumber-js";

// Bordered card for a block of content inside a settings page, matching the Preferences rows.
const SettingsSection = ({ title, description, extra, children, className = "", bodyClassName = "" }) => (
    <section className={`min-w-0 rounded-2xl border border-[#ECECF3] bg-white ${className}`}>
        {title || extra ? (
            <div className="flex flex-col gap-3 border-b border-[#ECECF3] px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
                <div className="min-w-0">
                    {title ? <h2 className="text-[16px] font-semibold text-[#2F2F46]">{title}</h2> : null}
                    {description ? <p className="mt-1 text-[14px] text-[#787882]">{description}</p> : null}
                </div>
                {extra ? <div className="flex shrink-0 flex-wrap items-center gap-2">{extra}</div> : null}
            </div>
        ) : null}
        <div className={`px-4 py-4 sm:px-6 sm:py-5 ${bodyClassName}`}>{children}</div>
    </section>
);

SettingsSection.propTypes = {
    title: PropTypes.node,
    description: PropTypes.node,
    extra: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    bodyClassName: PropTypes.string,
};

// Read-only label/value pair; place inside a <dl> grid.
export const SettingsInfoField = ({ label, children, className = "" }) => (
    <div className={`min-w-0 ${className}`}>
        <dt className="mb-1 text-[13px] text-[#787882]">{label}</dt>
        <dd className="break-words text-[14px] font-medium text-[#2F2F46]">{children || "—"}</dd>
    </div>
);

SettingsInfoField.propTypes = {
    label: PropTypes.node.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
};

/** Phone numbers are stored as bare digits with the country code (e.g. "13055550123"). */
export const formatSettingsPhone = (value) => {
    if (!value) return "";
    const parsed = parsePhoneNumberFromString(`+${String(value).replace(/^\+/, "")}`);
    return parsed?.formatInternational?.() || value;
};

export default SettingsSection;
